import { Injectable } from '@angular/core';
import { MessageService } from "primeng/api";

@Injectable({
  providedIn: 'root'
})
export class MessageHandlerService {

  constructor(private messageService: MessageService) { }

  /** sticky: the toast stays until closed, for a message too long to read in the default few seconds. */
  generateToastMessage(severity: string, summary: string, detail: string, sticky = false) {
    this.messageService.add({severity: severity, summary: summary, detail: detail, ...(sticky ? {sticky: true} : {})});
  }
}
